
/// <reference path="../../meevoStore.module.ts" />
module Meevo.Plugins.MeevoStore {

    class ModalPurchaseController {

        static $inject = [
            "$filter",
            '$state',
            "$mdDialog",
            "$translate",
            "meevo.AppSettings",
            'modalTitle',
            'modalText',
            'orderNumber',
            'url',
        ];

        constructor(
            protected $filter: angular.IFilterService,
            protected $state: ng.ui.IStateService,
            protected $mdDialog: angular.material.IDialogService,
            protected $translate: angular.translate.ITranslateService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            public modalTitle: string,
            public modalText: any,
            public orderNumber: string,
            public url: string) {

        }

        goToStoreHome () {
            this.$mdDialog.hide({ status: false });

            this.$state.go(this.appSettings.ROUTE_NAMES.meevoStore + '.home');
        };

        apply = () => {
            this.$mdDialog.hide({ status: true });
        };

        cancel = () => {
            this.$mdDialog.hide({ status: false });
        };
    }

    angular.module("meevo.plugins.meevoStore")
        .controller("meevo.plugins.meevoStore.ModalPurchaseController", ModalPurchaseController);
}